export default {
  'documents': {
    'molecules': {
      'add-stocktake-modal': {
        'stocktake-record': 'Stocktake Record',
        'storage-location': 'Storage location',
        'import-zero-stocks': 'Import products with zero stock',
        'copy-from-stock': 'Copy count from stock',
        'empty-commodities': 'Storage location should contain at least one product',
      },
      'details-header-buttons': {
        'transaction': 'Transaction',
        'order-details': 'Order details',
        'supply-details': 'Supply Details',
        'create-supply': 'Create Supply',
        'order-again': 'Order Again',
      },
      'details-row': {
        'product': 'Product',
        'qty-pcs': 'QTY (PCS)',
        'pcs': 'PCs',
        'qty-units': 'QTY (UNITS)',
        'qty': 'QTY',
        'real-qty': 'Real QTY',
        'unit': 'Unit',
        'storage': 'Storage',
        'unit-net': 'Unit net',
        'unit-gross': 'Unit gross',
        'value-net': 'Value net',
        'value-gross': 'Value gross',
        'package': 'package',
        'tax-amount': 'Tax amount',
        'tax-rate': 'Tax rate',
      },
      'products-list': {
        'product': 'Product',
        'brand': 'Brand',
        'qty': 'QTY',
        'price': 'Price',
      },
    },
    'organisms': {
      'add-product-modal': {
        'add-product': 'Add Product',
        'add-product-input-search': 'Search product',
        'all-products': 'All Products',
      },
      'details-info-form': {
        'issue-date': 'Issue date',
        'hour': 'Hour',
        'move-from-location': 'Move from location',
        'issued-by': 'Issued by',
        'storage-location': 'Storage location',
        'move-to-location': 'Move to location',
        'approved-by': 'Approved by',
        'note': 'Note',
        'expediture-reason': 'Expenditure reason',
        'supplier': 'Supplier',
        'to-stock-order': 'to Stock Order',
        'supplier-doc-num': 'Supplier document number',
        'send-email-supplier': 'Send email with order to Supplier',
        'no-supplier-email': 'The Supplier has no email address provided',
        'document-number': 'Document number',
        'no-suppliers-title': 'No suppliers added yet',
        'no-suppliers-text': 'Go to Inventory / Suppliers tab and add one.',
      },
    },
  },

  'products': {
    'molecules': {
      'category-select': {
        'search-category': 'Search category',
        'no-categories': 'No categories found...',
      },
      'product-item': {
        'product': 'Retail',
        'material': 'Professional',
      },
      'product-history': {
        'date': 'Date',
        'user': 'User',
        'field': 'Field',
        'before': 'Before',
        'after': 'After',
        'tax': 'Tax',
        'product-name': 'Product name',
        'brand': 'Brand',
        'photo': 'Photo',
        'created': 'Created',
        'status': 'Status',
        'barcodes': 'Barcodes',
        'main-category': 'Main Category',
        'tax-rate': 'Tax Rate',
        'net-price': 'Price (Net)',
        'gross-price': 'Price (Gross)',
        'suppliers': 'Suppliers',
        'description': 'Description',
        'measure-unit': 'Measure Unit',
        'catalog-name': 'Catalog Name',
        'sku': 'SKU',
        'product-type': 'Product Type',
        'total-pack-capacity': 'Units Per 1 PC',
        'extra-categories': 'Extra Categories',
        'additional-photos': 'Additional Photos',
        'enable-stock_control': 'Enable Stock Control',
        'retail-price': 'Retail Price (with Tax)',
        'retail': 'Retail',
        'professional': 'Professional',
        'archived': 'Archived',
        'active': 'Active',
        'enable-stock-control': 'Enable Stock Control',
        'on': 'On',
        'off': 'Off',
      },
      'product-summary': {
        'stock-on-hand-pcs': 'stock on hand (PCs)',
        'stock-on-hands-unit': 'stock on hand (units)',
        'retail-price-with-tax': 'retail price (with tax)',
      },
      'storage-product-history': {
        'date': 'Date',
        'field': 'Field',
        'before': 'Before',
        'change': 'Change',
        'after': 'After',
        'created': 'Created',
        'commodity': 'Commodity',
        'storage-location': 'Storage Location',
        'minimum-packages': 'Minimum Packages',
        'maximum-packages': 'Maximum Packages',
        'quantity': 'Quantity',
        'archived': 'Archived',
        'active': 'Active',
      },
    },
    'organisms': {
      'barcode-form': {
        'barcode': 'Barcode',
        'type': 'Type',
        'generate-new-code': 'Generate new code',
        'inavlid-code': 'Invalid code',
        'no-preview': 'No preview available',
        'enter-code': 'Enter or generate a code to show a preview.',
      },
      'category-edit-modal': {
        'label-add-category': 'Add category',
        'label-edit-category': 'Edit category',
        'label-category-name': 'Category name',
        'label-parent-category': 'Parent category',
        'message-category-created': 'Category created',
        'delete-category': 'Delete category?',
        'cannot-be-undone': 'This action cannot be undone',
      },
      'product-photo': {
        'cropper-title': 'Adjust photo',
        'cropper-description': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
        'add-media': 'Add media',
        'upload-new-photo': 'Upload new photo',
        'remove-photo': 'Remove photo',
      },
      'brand-form': {
        'brand-name': 'Brand name',
        'brand-created': 'Brand created',
      },
    },
  },

  'storage-locations': {
    'organisms': {
      'location-form': {
        'location-name': 'Storage location name',
        'type': 'Type',
        'note': 'Note (optional)',
        'default-description': 'Default storage location selected for all warehouse operations.',
        'address': 'Address',
        'city': 'City',
        'post-code': 'Post code',
        'country': 'Country',
      },
    },
  },

  'suppliers': {
    'molecules': {
      'address-info': {
        'street-address': 'Address',
        'city': 'City',
        'zip-code': 'Post code',
        'country': 'Country',
      },
      'general-info': {
        'supplier-name': 'Supplier name',
        'tax-id': 'Tax ID Number',
        'email': 'Email Address',
        'phone-number': 'Phone',
        'note': 'Note (optional)',
      },
    },
  },

  'shared': {
    'molecules': {
      'category-actions': {
        'archive': 'Archive',
        'order': 'Order',
        'delete': 'Delete',
        'activate': 'Activate',
      },
      'documents-stock-manager': {
        'new-stock-request-confirmation': 'New Stock Request Confirmation',
        'internal-product-expenditure': 'Internal Product Expenditure',
        'internal-stock-transfer': 'Internal Stock Transfer',
        'stock-intake-confirmation': 'Stock Intake Confirmation',
        'stock-order': 'Stock Order',
        'supply': 'Supply',
      },
      'products-table': {
        'label-product-name': 'Product name',
        'label-brand': 'Brand',
        'label-qty': 'Qty',
        'label-price': 'Price',
      },
    },
  },
}
